import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import './RemoveGroup.css';

class RemoveUser extends Component {
  render() {
    const { removeGroup, closeModal } = this.props;
    return (
      <div className="remove-group-modal-container">
        <div>
          <div className="text-container">
            <p>
              Are you sure you wish to remove this group?
            </p>
          </div>
          <div className="button-container">
            <Button onClick={() => removeGroup()}>Yes</Button>
            <Button onClick={() => closeModal()}>No</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default RemoveUser;